// Hífen de nome (cidade/bairro/empreendimento/tipo/referência) nos links /imoveis/...
// Régua dos ~300 sites: o hífen do nome vira "002D" ("Xangri-lá" → "xangri002dla"), porque o
// hífen da URL é o separador de palavras e o parser da busca reconstrói o nome exato.
// cs2588 (21/10/2026): o cliente pediu o link e o caminho (breadcrumb) da ficha sem o código —
// no Set, o hífen do nome fica hífen ("xangri-la"); a busca casa o segmento pelo slug com hífen
// (segmentoFiltroCasaNome) e o breadcrumb mostra o nome real. Link antigo com "002d" continua
// casando. Fora da lista, NADA muda.
export const URL_HIFEN_LITERAL = new Set<number>([2588]);

export const usaHifenLiteral = (codsite: unknown): boolean => URL_HIFEN_LITERAL.has(Number(codsite));

// Hífen de um nome para MONTAR o segmento da URL: "002D" na régua; o próprio hífen no gate.
export const hifenUrl = (nome: string, codsite: unknown): string =>
    usaHifenLiteral(codsite) ? nome : nome.replaceAll('-', '002D');
